var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterLine = function SvgFilterLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 4.8v1.8h-.9l-4.5 6.75V21H9.8v-7.65L5.3 6.6h-.9V4.8zM7.464 6.6l4.136 6.205v6.396h1.8v-6.396l4.136-6.204H7.464Z"
  })));
};
export default SvgFilterLine;